import { luhnCheck, validateCPF } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function CheckoutPaymentSchema() {
  const { t } = useTranslation('validation');

  const baseSchema = z.object({
    cardNumber: z
      .string()
      .min(1, t('notEmpty'))
      .refine(luhnCheck, {
        message: t('invalidCardNumber'),
      }),
    name: z.string().min(1, t('notEmpty')),
    expirationDate: z.string().min(1, t('notEmpty')),
    cvv: z.string().min(1, t('notEmpty')),
    document: z
      .string()
      .min(1, t('notEmpty'))
      .refine(validateCPF, {
        message: t('invalidCPF'),
      }),
    postalCode: z.string().min(1, t('notEmpty')),
    number: z.string().min(1, t('notEmpty')),
    complement: z.string(),
    street: z.string().min(1, t('notEmpty')),
    district: z.string().min(1, t('notEmpty')),
    city: z.string().min(1, t('notEmpty')),
    state: z.string().min(1, t('notEmpty')),
  });

  return baseSchema;
}

export type ICheckoutPaymentForm = z.infer<
  ReturnType<typeof CheckoutPaymentSchema>
>;
